import { create, show, useModal } from "@ebay/nice-modal-react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import useUpdateUser from "views/Account/Settings/User/useUpdateUser";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";

import { UserViewDetails } from "../../types";
import { GET_USER_WITH_ROLES } from "../../gql";

type SlackIntegrationDeleteConfirmationProps = {
  user: UserViewDetails;
};

const SlackIntegrationDeleteConfirmation = create(function SlackIntegrationDeleteConfirmation({
  user,
}: SlackIntegrationDeleteConfirmationProps) {
  const modal = useModal();
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const { onUpdate, loading } = useUpdateUser([
    {
      query: GET_USER_WITH_ROLES,
      variables: { id: user.id },
    },
  ]);

  const handleDelete = () => {
    onUpdate({ slackMemberID: null, accessRules: user.accessRules, id: user.id })
      .then(() => {
        modal.resolve();
        modal.hide();
        reportSuccess({ message: "Slack integration successfully deleted" });
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete Slack integration"
      name={`${user.username}'s Slack integration`}
      onConfirm={handleDelete}
      isLoading={loading}
      isDismissable={!loading}
    />
  );
});

export const showSlackIntegrationDeleteConfirmation = (
  props: SlackIntegrationDeleteConfirmationProps
) => show(SlackIntegrationDeleteConfirmation, props);
